import { Navigate } from "react-router-dom";

/** Legacy route — redirects to full Company Safety Policy. */
const ZeroTolerancePolicy = () => (
  <Navigate to="/company-safety-policy" replace />
);

export default ZeroTolerancePolicy;
